module.exports = __webpack_public_path__ + "img/zoom-out.298c004c.svg";